/* global Raven */
import globals from "util/globals";
import includes from "lodash/includes";

export default {
    notify(message, severity, extras, skipProd = false) {
        // Until we do a bigger rewrite of client-side logging with proper releases and npm-ing, just use Raven globally.
        let isDev = false;
        let isNotProd = false;

        if (typeof window !== "undefined") {
            const currentEnv = globals.get("environment");
            isDev = includes(["LOCAL", "TESTING", "DEVELOPMENT"], currentEnv);
            isNotProd = includes(["LOCAL", "TESTING", "DEVELOPMENT", "STAGING"], currentEnv);
        }
        if (typeof Raven !== "undefined") {
            let options = {
                level: severity,
                tags: {
                    site: "www"
                }
            };

            if (extras) {
                options.extra = extras;
            }
            if (!skipProd || isNotProd) {
                Raven.captureMessage(message, options);
            }
        }

        // log to console on development environments
        if (isDev) {
            let logMethod;
            switch (severity) {
                case "warning":
                    logMethod = window.console.warn;
                    break;
                case "error":
                    logMethod = window.console.error;
                    break;
                default:
                    logMethod = window.console.log;
            }
            logMethod(message, extras);
        }
    },

    setSessionId(sessionId) {
        if (typeof Raven !== "undefined") {
            Raven.setTagsContext({ SessionId: sessionId });
        }
    },

    setUserId(userId) {
        if (typeof Raven !== "undefined") {
            Raven.setTagsContext({ UserId: userId });
        }
    }
};
